// Dia de vencimento da mensalidade do Núcleo, escolhido pelo próprio lojista.
import axios from "axios";

const API = "/api";
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

export const diaVencimentoApi = {
  ver: () => axios.get(`${API}/billing/dia-vencimento`, auth()),
  trocar: (dia) => axios.post(`${API}/billing/dia-vencimento`, { dia }, auth()),
};
